module.exports = __webpack_public_path__ + "media/images/restaurant/areas/kyoto-4f686cf3b23ca679f9e8cdc97521261d.png";